import * as yup from 'yup';
import useValidators from 'components/Form/validations/useValidators';
import { TFunction } from 'i18next';

const useValidationSchema = (t: TFunction) => {
  const { required, withoutDiacritics } = useValidators();

  const StationFormSchema = yup.object().shape({
    code: withoutDiacritics(required(yup.string())),
    aetitle: required(yup.string()),
    modalityId: required(yup.mixed()),
  });

  const formItems = [
    {
      name: 'code',
      label: t('code'),
      required: true,
    },
    {
      name: 'aetitle',
      label: t('aetitle'),
      required: true,
    },
  ];

  return { StationFormSchema, formItems };
};

export default useValidationSchema;
